import axios from 'axios';
import { getApiUrl } from '../utils/apiClient';

// APIインスタンスを動的に作成
const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// リクエストインターセプターでbaseURLを動的に設定
api.interceptors.request.use(
  (config) => {
    // 毎回最新のURLを取得
    const baseURL = getApiUrl();

    // URLが相対パスの場合はbaseURLを追加
    if (config.url && !config.url.startsWith('http')) {
      config.url = baseURL + config.url;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export interface MenuItem {
  id: string;
  category: string;
  name: string;
  price: number;
  stock: number;
  active: number;
}

export interface Transaction {
  id?: number;
  order_type: 'eatin' | 'takeout';
  payment_type: 'cash' | 'paypay';
  subtotal: number;
  tax: number;
  total: number;
  items: CartItem[];
}

export interface CartItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
}

export interface SalesSummary {
  total_transactions: number;
  total_sales: number;
  cash_sales: number;
  paypay_sales: number;
  eatin_count: number;
  takeout_count: number;
}

export const menuApi = {
  getAll: async (): Promise<MenuItem[]> => {
    const response = await api.get('/menus');
    return response.data;
  },
};

export const transactionApi = {
  create: async (transaction: Transaction): Promise<{ id: number; message: string }> => {
    const response = await api.post('/transactions', transaction);
    return response.data;
  },
  
  getToday: async (): Promise<Transaction[]> => {
    const response = await api.get('/transactions/today');
    return response.data;
  },
};

export const salesApi = {
  getSummary: async (): Promise<SalesSummary> => {
    const response = await api.get('/sales/summary');
    return response.data;
  },
};

export default api;